function setFreeGiftDiscount(price) {
  let tier = 0;
  let tiers = [100, 150, 250, 500, 1000, 2000, 3000, 4000];

  for (let i = 0; i < tiers.length; i++) {
    if ((price / 100).toFixed(2) >= tiers[i]) tier = tiers[i];
  }

  var products = $("[data-tier]").sort(function (a, b) {
    return (
      parseInt($(b).data("tier")) - parseInt($(a).data("tier")) ||
      parseInt($(a).data("price")) - parseInt($(b).data("price"))
    );
  });

  products.each(function (_i, el) {
    if ($(el).data("tier") <= tier) {
      $(".cart-drawer-form #discount").val(`FG${$(el).data("tier")}`);
      return false;
    }
  });
}

function openCartDrawer() {
  const closeButton = document.querySelector(".cart-drawer-header-right-close");
    const cartDrawerCount = document.querySelector(".cart-drawer-header-right-items");

  const cartDrawerHeader = document.querySelector(".cart-drawer-header");
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  document.querySelector("body").style.overflow = "hidden";
  cartDrawerHeader.focus();
  const cartUpsell = document.querySelector(".cart-upsell");
  if (cartUpsell) {
    cartUpsell.classList.add("active");
  }
  // This is done because when cart drawer opens the focus needs to be shifted to it fo accessability due to the html structure of the drawert beeing at the end of the page/document
  if (cartDrawerCount) {
    cartDrawerCount.focus();
  }

  let price = 0;
  let cart = window.cartContents;
  cart.items?.map((item) => {
    if (item.product_type !== "Free Gifts") {
      price = price + item.price * item.quantity;
    }
  });
  setFreeGiftDiscount(price);
}

function closeCartDrawer() {
  const cartButton = document.querySelector(".focus-after-cart");
  cartButton.focus();
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
  document.querySelector("body").style.overflow = "";

  const cartUpsell = document.querySelector(".cart-upsell");
  if (cartUpsell) {
    cartUpsell.classList.remove("active");
  }
}

function updateCartItemCounts(count) {
  var addItemEvent = new CustomEvent("addItemToCart", {
    bubbles: true,
    cancelable: true,
  });
  document.dispatchEvent(addItemEvent);

  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
          

  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  $(".addon-button").on("click", function (e) {
    e.preventDefault();
    let reload = false;
    if ($(this).hasClass("page-addon")) {
      reload = true;
    }
    const $addonItem = $(this).closest(".addon-item");
    const $selectedVariant = $addonItem.find(".addon-variant.selected");
    // const data = {
    //   id: $selectedVariant.data("id"),
    //   quantity: 1,
    //   properties: {
    //     "Item#": $selectedVariant.data("sku"),
    //     " ": $selectedVariant.data("stock"),
    //   },
    // };
    const data = [
      { name: 'id', value: $selectedVariant.data("id") },
      { name: 'quantity', value: 1 },
      { name: 'properties[Item#]', value: $selectedVariant.data("sku") },
      { name: 'properties[_stock]', value: $selectedVariant.data("stock") }
    ];
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        if (reload) {
          window.location.reload();
        } else {
          updateCartDrawer().then(() => {
            var addItemEvent = new CustomEvent("addItemToCart", {
              bubbles: true,
              cancelable: true,
            });
            document.dispatchEvent(addItemEvent);
          });
        }
      },
    });
  });

  $(".addon-variant").on("click", function (e) {
    e.preventDefault();
    const $addonItem = $(this).closest(".addon-item");
    $addonItem.find(".addon-variant.selected").removeClass("selected");
    $(this).addClass("selected");

    const priceText = $(this).data("price");

    if (priceText) {
      $addonItem.find(".addon-button").text(priceText);
    }
  });

  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);

        // Update cart
        await updateCartDrawer();

        let price = 0;
        cart.items?.map((item) => {
          if (item.product_type !== "Free Gifts") {
            price = price + item.price * item.quantity;
          }
        });
        setFreeGiftDiscount(price);
      });
    });

  document.querySelectorAll(".remove-item").forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      // Get line item key
      const rootItem =
        button.parentElement.parentElement.parentElement.parentElement
          .parentElement;
      const key = rootItem.getAttribute("data-line-item-key");
      const newQuantity = 0;

      // Ajax update\
      const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: newQuantity } }),
      });
      const cart = await res.json();

      updateCartItemCounts(cart.item_count);

      // Update cart
      await updateCartDrawer();

      let price = 0;
      cart.items?.map((item) => {
        if (item.product_type !== "Free Gifts") {
          price = price + item.price * item.quantity;
        }
      });
      setFreeGiftDiscount(price);
    });
  });

  document.querySelectorAll(".cart-drawer-quantity-input").forEach((input) => {
    input.addEventListener("change", async () => {
      // Get line item key
      const rootItem =
        input.parentElement.parentElement.parentElement.parentElement
          .parentElement;
      const key = rootItem.getAttribute("data-line-item-key");

      const newQuantity = Number(input.value);

      // Ajax update\
      const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: newQuantity } }),
      });
      const cart = await res.json();

      updateCartItemCounts(cart.item_count);

      // Update cart
      await updateCartDrawer();

      let price = 0;
      cart.items?.map((item) => {
        if (item.product_type !== "Free Gifts") {
          price = price + item.price * item.quantity;
        }
      });
      setFreeGiftDiscount(price);
    });

    input.addEventListener("onsubmit", async (event) => {
      event.preventDefault();
    });
  });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(
      ".cart-drawer-header-right-close, .cart-drawer, .drawer-close"
    )
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    if (!e.target.classList.contains("full-cart")) {
      e.preventDefault();
      openCartDrawer();
    }
  });
});

async function syncCartFromServer() {
  try {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    const cart = await res.json();
    window.cartContents = cart;
    updateCartItemCounts(cart.item_count);
    await updateCartDrawer();
  } catch (e) {
    console.error("Cart sync failed", e);
  }
}

window.addEventListener("pageshow", function (event) {
  const nav = performance.getEntriesByType("navigation")[0];
  if (event.persisted || (nav && nav.type === "back_forward")) {
    syncCartFromServer();
  }
});